import { h, app } from 'hyperapp'
import { AllHtmlEntities as Entities } from 'html-entities';
import Dropdown from './inc/Dropdown'

if ( typeof storiesLandingData !== 'undefined' ) {
	( function( storiesLandingData ) {

		if ( ! document.getElementById( 'stories-landing' ) ) {
			return
		}

		const entities = new Entities();

		let showLoadMoreButton = false;
		if ( storiesLandingData.data.posts.length <= parseInt( storiesLandingData.postsPerPage ) ) {
			showLoadMoreButton = true;
		}

		const state = {
			ajaxUrl: storiesLandingData.ajaxUrl,
			stories: storiesLandingData.data.posts,
			categories: storiesLandingData.data.categories,
			media_types: storiesLandingData.data.media_types,
			showLoadMore: showLoadMoreButton,
			postsPerPage: storiesLandingData.postsPerPage,
			page: 1,
			filters: {
				'category': '',
				'media_type': '',
			}
		};

		const actions = {
			updateFilters: ( filter ) => ( state, actions ) => {
				const nextState = Object.assign( {}, state );

				nextState.filters = Object.assign(
					{},
					state.filters,
					{
						[ filter.key ]: filter.value
					}
				);

				actions.getFilteredStories( nextState )

				return nextState;
			},

			getFilteredStories : value => ( state, actions ) => {

				actions.resetPageCount()

				let filters = value.filters
				filters['page'] = 1

				$.ajax({
					method: 'POST',
					data : {
						action : 'get_filtered_stories',
						filters : filters
					},
					url: state.ajaxUrl,
					success: function( response ) {
						let posts = JSON.parse( response )

						actions.setStories( JSON.parse( response ) )

						if ( posts.length < state.postsPerPage ) {
							actions.disableLoadMore()
						} else {
							actions.enableLoadMore()
						}
					}
				})
			},

			addFilteredStories : value => ( state, actions ) => {

				let filters = state.filters
				filters['page'] = state.page + 1

				actions.upPageCount()

				$.ajax({
					method: 'POST',
					data : {
						action : 'get_filtered_stories',
						filters : filters
					},
					url: state.ajaxUrl,
					success: function( response ) {
						let posts = JSON.parse( response )

						if ( 0 === posts.length ) {
							actions.disableLoadMore()
						} else {
							actions.addStories( JSON.parse( response ) )
						}

						if ( posts.length < state.postsPerPage ) {
							actions.disableLoadMore()
						}
					}
				})
			},

			upPageCount: value => state => state.page = state.page + 1,

			resetPageCount: value => state => state.page = 1,

			setStories: value => state => state.stories = value,

			addStories: value => state => state.stories = state.stories.concat( value ),

			disableLoadMore: value => state => state.showLoadMore = false,

			enableLoadMore: value => state => state.showLoadMore = true,
		};

		const Filters = ( { actions, state } ) => {

			const filters = state.filters;
			const topics = state.topics;

			return (
				<div class="program-finder__filters">
					<span class="or-text">Filter By: </span>
					<CategoryFilter categories={ state.categories } actions={ actions } filters={ filters } />
					<MediaTypeFilter media_types={ state.media_types } actions={ actions } filters={ filters } />
				</div>
			);
		}

		const CategoryFilter = ( { actions, filters, categories } ) => {

			const setCategory = ( e, id, name ) => {
				actions.updateFilters({ key: 'category', value: id })
			}

			if ( categories ) {

				return (
					<Dropdown ariaLabel="All Categories" onClickFunc={ setCategory } header="All Categories" list={ categories } />
				)

			}

			return null
		}

		const MediaTypeFilter = ( { actions, filters, media_types } ) => {

			const setMediaType = ( e, id, name ) => {
				actions.updateFilters({ key: 'media_type', value: id })
			}

			if ( media_types ) {

				return (
					<Dropdown ariaLabel="All Media Types" onClickFunc={ setMediaType } header="All Media Types" list={ media_types } />
				)

			}

			return null
		}

		const filterTopics = ( collection, filters ) => {
			if ( ! filters ) {
				return collection;
			}

			return collection;
		}

		const StoriesList = ({ stories }) => {

			return (
				<div class="stories-landing__list">
					{ stories.map( story => {
						return (
							<StoryItem story={ story } />
						)
					})}
				</div>
			)
		}

		const MediaIcon = ({ media_type }) => {

			let mediaDisplay = ''
			if ( 'string' == typeof media_type.icon ) {
				mediaDisplay = <div class="circle-icon media-circle-icon"><span class={ media_type.icon }></span></div>
			}

			if ( mediaDisplay ) {
				return mediaDisplay
			}

		}

		const StoryItem = ({ story, state }) => {

			let mediaTypeText = ( '' != story.media_type ) ? <div class="media-type">{ entities.decode( story.media_type.name ) }</div> : ''

			const label = story.section_label ? <p class="subtitle">{ story.section_label }</p> : ''

      console.log( story );

			return (
				<div class="stories-landing__item">

					<div class="image">
						<a aria-hidden="true" target={ entities.decode( story.target ) } href={ entities.decode( story.url ) }>
							<img src={ story.image.url }
								 width={ story.image.width }
								 height={ story.image.height }
								 alt={ story.image.alt } />
							<MediaIcon media_type={ story.media_type } />
						</a>
					</div>

					<div class="text">
						{ label }
						<div class="h5__title">
							<a target={ entities.decode( story.target ) } href={ entities.decode( story.url ) }>
								{ entities.decode( story.name ) }
							</a>
						</div>
						{ mediaTypeText }
					</div>

				</div>
			);
		}

		const LoadMoreButton = ({ state, actions }) => {

			const loadMoreStories = ( state, actions ) => {
				actions.upPageCount()
			}

			if ( state.showLoadMore ) {
				return (
					<button class="reset outline-button grey stories-landing__load-more-btn secondary" onclick={ () => { actions.addFilteredStories() } }>
						Load More
					</button>
				)
			}
		}

		const view = ( state, actions ) => {
			return (
				<div class="program-finder__container">
					<Filters state={ state } actions={ actions } />
					<StoriesList stories={ state.stories } />
					<LoadMoreButton state={ state } actions={ actions } />
				</div>
			)
		}

		const App = app( state, actions, view, document.getElementById( 'stories-landing' ) )

	} ( storiesLandingData ) );
}



// WEBPACK FOOTER //
// ./assets/js/stories.js